import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import WaterPurification from '../pages/water-purification/page';
import WindowsServicesPage from '../pages/windows-services/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/water-purification',
    element: <WaterPurification />,
  },
  {
    path: '/windows-services',
    element: <WindowsServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
